module.exports = __webpack_public_path__ + "./img/whatsapp.bb1b2eb9e206e64b067ac4c65f731539.png";


//////////////////
// WEBPACK FOOTER
// ./src/medias/whatsapp.png
// module id = ./src/medias/whatsapp.png
// module chunks = 0